import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import type { DynamicDialogConfig } from 'primeng/dynamicdialog';
import type { DynamicDialogData } from '@bizzdesign/modeler/models';

export const dialogPublishSuccessUiEvents = eventGroup({
  source: 'Dialog Publish Success UI',
  events: {
    viewOpened: type<{ readonly viewId: string; readonly viewName: string }>(),
    dialogClosed: type<void>(),
    dialogOpened: type<DynamicDialogConfig<DynamicDialogData>>(),
  },
});
